<template>
  <AlertCard :title="title" :desc="desc" :type="type" />
</template>
<script>
import { ref, onMounted } from "vue";
import AlertCard from "./AlertCard.vue";

export default {
  components: { AlertCard },
  setup() {
    // data 정의
    const type = ref("fail");
    const title = ref("서버 내부 오류가 발생했습니다.");
    const desc = ref(
      "죄송합니다.<br>현재 웹사이트에 기술적인 문제가 발생했습니다.<br>잠시 후 다시 시도해 주십시오. 불편을 드려 죄송합니다."
    );

    onMounted(() => {
      type.value = sessionStorage.getItem("errorType");
      const message = sessionStorage.getItem("errorMsg");

      title.value = sessionStorage.getItem("errorTitle");
      desc.value = message?.replace(/\n/g, "<br>") || "오류가 발생했습니다.";
    });

    // html에서 사용될 데이터 정의
    return {
      title,
      desc,
      type,
    };
  },
};
</script>
